export default {
  ALL_TIME:   'allTime',
  LAST_MONTH: 'lastMonth',
  LAST_WEEK:  'lastWeek',
  TODAY:      'today'
};